var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({ref:"fileInput",staticClass:"file-input-hidden",attrs:{"type":"file"},on:{"change":function($event){return _vm.sendRequest()}}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }